import { HeroControlOverflow, Menu, MenuContent, MenuItem, MenuTrigger } from '@wundo/ui';
import { CircleMinus } from 'lucide-react';
import { m } from '@/paraglide/messages.js';

export interface MeetingMoreControlProps {
  /** Asked to take Wundo off this conversation; the dialog settles how far. */
  onRemove: () => void;
}

/**
 * The end of the row under the hero: what can be done to this conversation, as
 * opposed to what it is set to.
 *
 * Removal lives here rather than beside the settings because it is not one of
 * them — a control saying "Wundo aan" next to "Notetaker aan" would make helping
 * look like a switch, and it is a thing that is added and a thing that is taken
 * away. Folded behind a "…" for the same reason the bar carries no third
 * button: nobody comes to this page to leave it.
 */
export function MeetingMoreControl({ onRemove }: MeetingMoreControlProps) {
  return (
    <Menu>
      <MenuTrigger
        render={<HeroControlOverflow aria-label={m.meeting_more_actions()} />}
      />
      <MenuContent align='end'>
        <MenuItem tone='danger' onClick={onRemove}>
          <CircleMinus aria-hidden='true' />
          {m.meeting_remove_wundo()}
        </MenuItem>
      </MenuContent>
    </Menu>
  );
}
